import { Crosshair, Target, Rocket, Bomb, Swords, Hand, Truck, Blocks, Wrench, Skull } from "lucide-react";

// Maps a backend weapon_cat to a small lucide glyph so kills are scannable at a glance.
const CAT_ICON = {
  rifle: Crosshair, smg: Crosshair, lmg: Crosshair, pistol: Crosshair,
  sniper: Target, bow: Target, launcher: Rocket,
  explosive: Bomb, melee: Swords, fists: Hand,
  vehicle: Truck, build: Blocks, tool: Wrench, unknown: Skull,
};

export const weaponCatIcon = (cat) => CAT_ICON[cat] || Crosshair;

export const WeaponGlyph = ({ cat, className = "w-3 h-3", ...rest }) => {
  const Icon = weaponCatIcon(cat);
  return <Icon className={className} {...rest} />;
};
